import React from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';

const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
  height: 80vh;
  overflow: hidden;
`;

const VideoSlide = styled.div`
  position: relative;
  height: 80vh;
`;

const Video = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: relative;
  z-index: 1; /* Ensure it's below everything else */
`;


const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.3),
    rgba(0, 0, 0, 0.5)
  );
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
`;

const Content = styled.div`
  text-align: center;
  color: white;
  max-width: 800px;
  padding: ${({ theme }) => theme.spacing.large};
  z-index: 3;
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.5s ease;

  .slick-active & {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Title = styled.h1`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: 3.5rem;
  margin-bottom: ${({ theme }) => theme.spacing.medium};
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  color: ${({ theme }) => theme.colors.gold.light};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 2.5rem;
  }
`;

const Subtitle = styled.p`
  font-size: 1.4rem;
  margin-bottom: ${({ theme }) => theme.spacing.large};
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
  font-family: ${({ theme }) => theme.fonts.secondary};
  color: ${({ theme }) => theme.colors.secondary};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 1.2rem;
  }
`;

const videos = [
  {
    url: "/videos/video.mp4",
    title: "Elegant Collection",
    subtitle: "Discover our handcrafted imitation jewellery pieces"
  },
  {
    url: "/videos/video.mp4",
    title: "Traditional Beauty",
    subtitle: "Embrace the richness of Indian heritage"
  },
  {
    url: "/videos/video.mp4",
    title: "Modern Glamour",
    subtitle: "Perfect blend of tradition and contemporary style"
  }
];

const VideoCarousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    cssEase: 'linear',
    pauseOnHover: false
  };

  return (
    <CarouselContainer>
      <Slider {...settings}>
        {videos.map((video, index) => (
          <VideoSlide key={index}>
            <Video autoPlay muted loop playsInline>
              <source src={video.url} type="video/mp4" />
            </Video>
            <Overlay>
              <Content>
                <Title>{video.title}</Title>
                <Subtitle>{video.subtitle}</Subtitle>
              </Content>
            </Overlay>
          </VideoSlide>
        ))}
      </Slider>
    </CarouselContainer>
  );
};

export default VideoCarousel;
